const borderRadius = 4;

function addRoundedRect(e, x, y, width, height, radius, strokeWidth) {
  // credit: https://stackoverflow.com/a/61449329/376409

  const s = strokeWidth / 2;

  const over = 2 * radius + strokeWidth;

  const w = width - over;
  const h = height - over;

  const d = `
        M${radius + s + x},${s + y}
        h${w}
        a${radius},${radius} 0 0 1 ${radius},${radius}
        v${h}
        a${radius},${radius} 0 0 1 -${radius},${radius}
        h-${w}
        a${radius},${radius} 0 0 1 -${radius},-${radius}
        v-${h}
        a${radius},${radius} 0 0 1 ${radius},-${radius}
        z
    `;

  return e.append("path").attr("d", d).attr("stroke-width", strokeWidth);
}

export { addRoundedRect, borderRadius };
